import type { SVGProps } from 'react';
const SvgUnlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF073B"
      d="M11.416 1.225a5.8 5.8 0 0 1 6.267 4.616.8.8 0 1 1-1.568.318A4.2 4.2 0 0 0 7.8 7V10.2h11.2a2.8 2.8 0 0 1 2.8 2.8v7a2.8 2.8 0 0 1-2.8 2.8h-14a2.8 2.8 0 0 1-2.8-2.8v-7A2.8 2.8 0 0 1 5 10.2h1.2V7a5.8 5.8 0 0 1 5.217-5.775M4.999 11.8a1.2 1.2 0 0 0-1.2 1.2v7a1.2 1.2 0 0 0 1.2 1.2h14a1.2 1.2 0 0 0 1.2-1.2v-7a1.2 1.2 0 0 0-1.2-1.2z"
    />
  </svg>
);
export default SvgUnlock;
